/**
 * @fileoverview Renders a lone across the box, showing the median of
 * the distribution.
 */

import React from 'react'

export default function MedianLine({ x, y, width }) {
  return (
    <line x1={x} x2={x + width} y1={y} y2={y} stroke="white" opacity="0.9" />
  )
}



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/shapes/easing-box/median-line.js